// components/markers/StackedMarker.jsx
import { useState } from "react";
import { Badge } from "react-bootstrap";
import circle from "../../../assets/img/m1.png/clusterIcon.png";

/**
 * Displays a count badge for stacked items at the same position.
 * On click, opens an inline list to pick a single item.
 */
export function StackedMarker({ group, isSelected, onSelect }) {
  // const [listOpen, setListOpen] = useState(false);

  // const handleClick = () => setListOpen((open) => !open);

  // const handleItemSelect = (item) => {
  //   setListOpen(false);
  //   onSelect([item]);
  // };

  return (
    <div style={{ position: "relative", transform: "translateY(50%)" }}>
      <img src={circle} width="24px" alt="Cluster" />
      <div
        style={{
          position: "absolute",
          top: "100%",
          left: "50%",
          transform: "translateX(-50%)",
          marginTop: 4,
          pointerEvents: "none",
        }}
      >
        <Badge pill bg="secondary">
          {group.count}
        </Badge>
      </div>
    </div>
  );
}
